import { User } from "./User";

export const REPORT_STATUS = {
  IN_REVIEW: "in-review",
  NORMAL: "normal",
  RESTRICTED: "restricted",
} as const;

export type ReportStatus = (typeof REPORT_STATUS)[keyof typeof REPORT_STATUS];

export type ReportUserEntity = {
  id: number;
  type: string;
  info?: string;
  status?: ReportStatus | null;
  reporter: User;
  reported: User;
  createdAt: string;
};

export type ReportJobPostEntity = {
  id: number;
  type: string;
  info?: string;
  status?: ReportStatus | null;
  reporter: User;
  reported: {
    id: number;
    title?: string;
  };
  createdAt: string;
};

export type UserBlockEntity = {
  id: number;
  reason?: string | null;
  info?: string | null;
  blocker: User;
  blocked: User;
  createdAt: string;
};

export type JobPostBlockEntity = {
  id: number;
  reason?: string | null;
  info?: string | null;
  blocker: User;
  blocked: {
    id: number;
    title?: string;
  };
  createdAt: string;
};
